import React, { useCallback, useState } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../head-container';
import classNames from 'classnames';
import { getImageFromS3 } from '../../../imageService';

const challengeList = [
  {
    id: 1,
    title: 'Який пейзаж надихає тебе найбільше?',
    answerList: [
      {
        id: 1.1,
        title: 'Тихий ліс',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/1.1.png'
        )
      },
      {
        id: 1.2,
        title: 'Величні льодовики',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/1.2.png'
        )
      },
      {
        id: 1.3,
        title: 'Безлюдна пустеля',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/1.3.png'
        )
      },
      {
        id: 1.4,
        title: 'Вогні нічного міста',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/1.4.png'
        )
      }
    ]
  },
  {
    id: 2,
    title: 'Як хочеш дістатись до місця сили?',
    answerList: [
      {
        id: 2.1,
        title: 'Мотоциклом',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/2.1.png'
        )
      },
      {
        id: 2.2,
        title: 'Снігоходом',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/2.2.png'
        )
      },
      {
        id: 2.3,
        title: 'Кораблем',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/2.3.png'
        )
      },
      {
        id: 2.4,
        title: 'Авторікшею',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/2.4.png'
        )
      }
    ]
  },
  {
    id: 3,
    title: 'На який смаковий експеримент наважишся?',
    answerList: [
      {
        id: 3.1,
        title: 'Змії',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/3.1.png'
        )
      },
      {
        id: 3.2,
        title: 'Новий рецепт риби',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/3.2.png'
        )
      },
      {
        id: 3.3,
        title: 'Щось на вогнищі',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/3.3.png'
        )
      },
      {
        id: 3.4,
        title: 'Зоофобуси',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/3.4.png'
        )
      }
    ]
  },
  {
    id: 4,
    title: 'Де заночуєш на час пригоди?',
    answerList: [
      {
        id: 4.1,
        title: 'Намет',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/4.1.png'
        )
      },
      {
        id: 4.2,
        title: 'Найближча хатинка',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/4.2.png'
        )
      },
      {
        id: 4.3,
        title: 'Готель',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/4.3.png'
        )
      },
      {
        id: 4.4,
        title: 'Орендована квартира',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/4.4.png'
        )
      }
    ]
  },
  {
    id: 5,
    title: 'Скільки часу тобі потрібно для перезавантаження?',
    answerList: [
      {
        id: 5.1,
        title: 'День-два',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/5.1.png'
        )
      },
      {
        id: 5.2,
        title: 'Тиждень',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/5.2.png'
        )
      },
      {
        id: 5.3,
        title: 'Місяць',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/5.3.png'
        )
      },
      {
        id: 5.4,
        title: 'Рік',
        image: getImageFromS3(
          '/images/what-kind-of-researcher-challenge/5.4.png'
        )
      }
    ]
  }
];

const resultList = [
  {
    id: 1,
    title: 'Першовідкривач',
    description:
      'Тебе не цікавлять протоптані стежки, адже знаходити щось нове — ось справжнє задоволення.\n' +
      '\n' +
      'Надихаємось твоєю відкритістю до нового!',
    image: getImageFromS3(
      '/images/what-kind-of-researcher-challenge/result1.png'
    )
  },
  {
    id: 2,
    title: 'Підкорювач гір',
    description:
      'Ти не шукаєш легких шляхів, а, навпаки, обираєш пригоди та прагнеш досягнути нових висот.\n' +
      '\n' +
      'Твоїй відвазі та сміливості можна позаздрити.',
    image: getImageFromS3(
      '/images/what-kind-of-researcher-challenge/result2.png'
    )
  },
  {
    id: 3,
    title: 'Вільний мандрівник',
    description:
      'Ти з тих людей, яких надихає шлях, а не кінцевий пункт. Твоя суперсила — насолоджуватись деталями.',
    image: getImageFromS3(
      '/images/what-kind-of-researcher-challenge/result3.png'
    )
  },
  {
    id: 4,
    title: 'Дослідник міста',
    description:
      'Ти легко знаходиш нове та цікаве навіть у буденних речах.\n' +
      '\n' +
      'У подорожах тебе легко сплутати з місцевим, адже ти швидко вливаєшся в новий ритм та культуру.\n',
    image: getImageFromS3(
      '/images/what-kind-of-researcher-challenge/result4.png'
    )
  }
];

const WhatKindOfResearcher = ({ setScreenNumber, afterResultButtonScreen }) => {
  const [challengeStep, setChallengeStep] = useState(0);
  const [selectQuestion, setSelectQuestion] = useState(challengeList[0]);
  const [correctAnswerValue, setCorrectAnswerValue] = useState(0);
  const [isWelcomeScreen, setIsWelcomeScreen] = useState(true);
  const [isResultScreen, setIsResultScreen] = useState(false);
  const [isAfterResultScreen, setAfterResultScreen] = useState(false);
  const [answers, setAnswers] = useState([]);

  const onAnswerClick = useCallback(
    (value) => {
      setAnswers((prev) => ({ ...prev, [challengeStep]: value }));
    },
    [answers, challengeStep]
  );

  const onFinishClick = () => {
    const answerCounts = {};
    for (const key in answers) {
      const answerNumber = parseInt(
        answers[key].answerId.toString().split('.')[1]
      );
      answerCounts[answerNumber] = (answerCounts[answerNumber] || 0) + 1;
    }

    let mostFrequentAnswer = null;
    let maxCount = 0;
    for (const answer in answerCounts) {
      if (answerCounts[answer] > maxCount) {
        maxCount = answerCounts[answer];
        mostFrequentAnswer = parseInt(answer);
      }
    }

    setCorrectAnswerValue(
      resultList?.find((item) => item?.id === mostFrequentAnswer)
    );
    setIsResultScreen(true);
  };

  return (
    challengeList && (
      <div
        className={styles.wrapper}
        style={{
          backgroundImage: `url(${getImageFromS3(
            '/images/what-kind-of-researcher-challenge/bg.png'
          )})`
        }}
      >
        <div style={{ padding: '20px 30px 0' }}>
          <HeadContainer setScreenNumber={setScreenNumber} />
        </div>
        {isWelcomeScreen && !isResultScreen && !isAfterResultScreen && (
          <div className={styles.welcomeContainer}>
            <p className={styles.title}>Який ти дослідник?</p>
            <p className={styles.description}>
              Готовий визначити, який стиль пригод тобі ближчий?<br></br>
              <br></br>
              Відповідай на запитання і дізнайся, хто ти у світі мандрів.
            </p>
            <button onClick={() => setIsWelcomeScreen(false)}>
              Приймаю челендж!
            </button>
          </div>
        )}
        {!isWelcomeScreen && !isResultScreen && !isAfterResultScreen && (
          <div className={styles.challengeContainer}>
            <div className={styles.stepToolbar}>
              {challengeList.map((item, index) => (
                <div
                  key={index}
                  className={classNames(
                    styles.stepItem,
                    index === challengeStep && styles.activeStepItem
                  )}
                />
              ))}
            </div>
            <div className={styles.questionContainer}>
              <p className={styles.title}>{selectQuestion?.title}</p>
              <div className={styles.imageList}>
                {selectQuestion &&
                  selectQuestion?.answerList?.map((item) => (
                    <div
                      key={item?.id}
                      className={classNames(
                        styles.imageItem,
                        item?.id === answers[challengeStep]?.answerId &&
                          styles.selectedImageItem
                      )}
                      onClick={() =>
                        onAnswerClick({
                          answerId: item?.id,
                          answer: item?.title
                        })
                      }
                    >
                      <img src={item?.image} alt={item?.image} />
                      <p>{item?.title}</p>
                    </div>
                  ))}
              </div>
            </div>
            <div className={styles.buttonContainer}>
              <div
                className={styles.leftButton}
                onClick={() => {
                  if (challengeStep > 0) {
                    setChallengeStep(challengeStep - 1);
                    setSelectQuestion(challengeList[challengeStep - 1]);
                  } else {
                    setIsWelcomeScreen(true);
                    setSelectQuestion(challengeList[0]);
                    setChallengeStep(0);
                    setIsResultScreen(false);
                    setAnswers([]);
                  }
                }}
              >
                <img
                  src="/images/luxury-expert-challenge/arrow.svg"
                  alt="arrow"
                />
                <span>Назад</span>
              </div>
              {answers[challengeStep]?.answerId && (
                <div
                  className={styles.rightButton}
                  onClick={() => {
                    if (challengeStep + 1 >= challengeList?.length) {
                      onFinishClick();
                      return;
                    }
                    setChallengeStep(challengeStep + 1);
                    setSelectQuestion(challengeList[challengeStep + 1]);
                  }}
                >
                  <span>Далі</span>
                  <img
                    src="/images/luxury-expert-challenge/arrow.svg"
                    alt="arrow"
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {isResultScreen && !isWelcomeScreen && !isAfterResultScreen && (
          <div className={styles.resultContainer}>
            <p className={styles.headResultTitle}>Результат</p>
            <img
              src={correctAnswerValue?.image}
              alt={correctAnswerValue?.title}
            />
            <p className={styles.title}>{correctAnswerValue.title}</p>
            <p className={styles.description}>
              {correctAnswerValue.description}
            </p>
            <button
              onClick={() => {
                setChallengeStep(0);
                setSelectQuestion(challengeList[0]);
                setCorrectAnswerValue(0);
                setIsWelcomeScreen(false);
                setIsResultScreen(false);
                setAfterResultScreen(true);
              }}
            >
              <span>Далі</span>
            </button>
          </div>
        )}
        {isAfterResultScreen && !isResultScreen && !isWelcomeScreen && (
          <div className={styles.afterResultContainer}>
            <p className={styles.title}>Світ чекає на твої відкриття!</p>
            <p className={styles.description}>
              Не зупиняйся, адже кожен день — це можливість нової пригоди.
            </p>
            <button
              onClick={() => {
                setChallengeStep(0);
                setSelectQuestion(challengeList[0]);
                setCorrectAnswerValue(0);
                setIsWelcomeScreen(true);
                setIsResultScreen(false);
                setAfterResultScreen(false);
                afterResultButtonScreen();
              }}
            >
              <span>Далі</span>
            </button>
          </div>
        )}
      </div>
    )
  );
};

export default WhatKindOfResearcher;
